import React from 'react';
import { Container, Row, Col, Badge, Card } from 'react-bootstrap';
import Button from '../../components/common/Button';

const SocialMediaManagement: React.FC = () => {
  const posts = [
    { id: 1, platform: 'Twitter', content: 'Launching our new feature today! 🚀', status: 'scheduled', date: '2025-08-20 10:00' },
    { id: 2, platform: 'Instagram', content: 'Behind the scenes with our team 👀', status: 'draft', date: '-' },
    { id: 3, platform: 'LinkedIn', content: 'We are hiring a Senior Engineer!', status: 'published', date: '2025-08-18 14:30' },
  ];

  const statusVariant = (s: string) => s === 'published' ? 'success' : s === 'scheduled' ? 'info' : 'secondary';

  const getPlatformIcon = (platform: string) => {
    switch (platform.toLowerCase()) {
      case 'twitter': return 'bi-twitter';
      case 'instagram': return 'bi-instagram';
      case 'linkedin': return 'bi-linkedin';
      case 'facebook': return 'bi-facebook';
      default: return 'bi-share';
    }
  };

  return (
    <Container fluid className="marketing-dashboard social-media">
      {/* Başlık Bölümü */}
      <div className="page-header">
        <div className="header-content">
          <div className="header-info">
            <div className="header-icon">
              <i className="bi bi-share-fill"></i>
            </div>
            <div className="header-text">
              <h1 className="page-title">Social Media</h1>
              <p className="page-subtitle">
                Manage and schedule your social media posts across platforms
              </p>
            </div>
          </div>
          <div className="header-actions">
            <Button
              variant="primary"
              leftIcon={<i className="bi bi-plus-lg"></i>}
              style={{ color: '#fff' }}
            >
              Create Post
            </Button>
          </div>
        </div>
      </div>

      <Row className="g-4">
        {posts.map(p => (
          <Col md={6} lg={4} key={p.id}>
            <Card className="content-card post-card h-100">
              <Card.Body className="card-body-custom">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className={`platform-badge ${p.platform.toLowerCase()}`}>
                    <i className={`bi ${getPlatformIcon(p.platform)}`}></i>
                    {p.platform}
                  </div>
                  <Badge bg={statusVariant(p.status)} pill>
                    {p.status}
                  </Badge>
                </div>
                <p className="post-content">{p.content}</p>
                <div className="d-flex justify-content-between align-items-center mt-4">
                  <div className="post-meta">
                    <i className="bi bi-calendar3"></i>
                    {p.date}
                  </div>
                  <div className="d-flex gap-2">
                    <Button variant="ghost" size="sm" iconOnly style={{ color: 'var(--text-secondary)' }}>
                      <i className="bi bi-pencil"></i>
                    </Button>
                    <Button variant="ghost" size="sm" iconOnly style={{ color: 'var(--text-secondary)' }}>
                      <i className="bi bi-eye"></i>
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default SocialMediaManagement;